export type TherapyTarget = 'another-adult' | 'adult' | 'child';

export type InsuranceType = 'work' | 'private' | 'medicaid' | 'medicare' | 'other';

export type InsuranceNetwork = 'inn' | 'inactive' | 'error' | 'onn';

export const MEDICAID_RELATIONSHIP_TO_INSURED_NUMBER = '18';

export enum PayerTypes {
  MEDICAID = 'MC',
  COMMERCIAL = 'CI',
  MEDICARE = 'MB',
}

export enum RelationShipsToClient {
  SELF = '18 - Self',
}

export enum VerificationTypes {
  AUTOMATED = 'Automated',
}

export enum InsuranceStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  NOT_CHECKED = 'Not Checked',
}

export enum SalesforcePayerTypes {
  MEDICAID = 'Medicaid',
  MEDICARE = 'Medicare',
  COMMERCIAL = 'Commercial',
  SELF_PAY = 'Self-pay',
  OTHER = 'Other',
  UNKNOWN = 'Unknown',
}

export type Physician = {
  name: string;
  office: string;
  phoneNumber: string;
  website: string;
  npi?: string;
};

export type PhysicianForm = {
  noPrimaryPhysician?: boolean;
  primaryPhysician?: Physician;
};

export type EnterMedicaidInsuranceForm = {
  notInsuranceAvailable: boolean;
  firstName: string;
  lastName: string;
  payerId: string;
  payerName: string;
  insuranceName: string;
  insurancePlan: string;
  dob?: Date;
  memberId: string;
  groupId: string;
  entity: string;
};

export type EnterInsuranceFormV4 = EnterMedicaidInsuranceForm & {
  state: string;
  npi?: string;
  networkStatus: string;
  allowSelfSignUp: boolean;
};
